import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAPI } from "../api/useAPI";
import { LOGGED_IN_HOME_PAGE } from "../config";
import { useBehaviorSubjectState } from "./useBehaviorSubjectState";

interface RedirectIfLoggedInProps {
  children: any;
}

export const RedirectIfLoggedIn = ({ children }: RedirectIfLoggedInProps) => {
  const api = useAPI();
  const [isLoggedIn] = useBehaviorSubjectState(api.isLoggedIn$);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(LOGGED_IN_HOME_PAGE);
    }
  }, [isLoggedIn, navigate]);

  if (isLoggedIn) {
    return null;
  }
  return <>{children}</>;
};
